import './assets/base.pcss';
import {exportConfig, updateConfig} from "./utils/config";
import {debug, error, warn} from "./utils/log";
import {loadCSS} from "./utils/css";
import {checkDependencies} from "./utils/dependency";
import {transformToTranslatableError} from "./utils/error";

// dynamically configure this module based on the URL parameters of the current page
updateConfig(new URLSearchParams(location.search))
// and the URL of this module
updateConfig(new URL(import.meta.url).searchParams);

debug("Configuration updated:", exportConfig());

function loadFallback(extraConfig: {[key: string]: unknown}) {
    const c: {[key: string]: unknown} = {}
    for (const [key, value] of exportConfig()) {
        c[key] = value
    }
    for (const [key, value] of Object.entries(extraConfig)) {
        c[key] = value;
    }
    window.__swssConfig = c;

    const script = document.createElement("script");
    script.src = `/__saasweb__/spam-shield/bundle/fallback.js`;
    document.head.appendChild(script)
}

const failedDep = checkDependencies()
if (failedDep) {
    warn(`Dependencies check failed: ${failedDep}`);
    loadFallback({'swss-error-id': 'failedDependency', 'swss-error-msg': failedDep});
} else {
    debug(`Dependencies check passed.`);
    import('./boot').then(module => module.init()).catch(err => {
        error("Failed to load POW module:", err);
        const e = transformToTranslatableError(err);
        loadFallback({'swss-error-id': e.id, 'swss-error-msg': e.msg});
    })
    loadCSS()
}
